const state = () => ({
    currentLanguage: 'zh-TW', // 默认繁体中文
    availableLanguages: [
        { code: 'zh-TW', name: '中文', flag: '🇨🇳' },
        { code: 'en', name: 'EN', flag: '🇺🇸' }
    ]
})

const getters = {
    getCurrentLanguage: (state) => state.currentLanguage,
    getAvailableLanguages: (state) => state.availableLanguages,
    getAvailableLanguageCodes: (state) => state.availableLanguages.map(v => v.code),
    getCurrentLanguageInfo: (state) => {
        return state.availableLanguages.find(lang => lang.code === state.currentLanguage)
    },
    isChinese: (state) => state.currentLanguage === 'zh-TW',
    isEnglish: (state) => state.currentLanguage === 'en'
}

const mutations = {
    SET_LANGUAGE(state, languageCode) {
        state.currentLanguage = languageCode
        // 保存到本地存储
        localStorage.setItem('app-language', languageCode)
    }
}

const actions = {
    initLanguage({ state, getters }) {
        // 从本地存储恢复语言设置
        const savedLanguage = localStorage.getItem('app-language')
        if (savedLanguage && getters.getAvailableLanguageCodes.includes(savedLanguage)) {
            state.currentLanguage = savedLanguage
        }
    },
    switchLanguage({ commit }, languageCode) {
        commit('SET_LANGUAGE', languageCode)
    },
    toggleLanguage({ commit, state }) {
        const newLanguage = state.currentLanguage === 'zh-TW' ? 'en' : 'zh-TW'
        commit('SET_LANGUAGE', newLanguage)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
} 